/* eslint-disable no-sparse-arrays */
// eslint-disable-next-line
import * as tokens from '@mediahuis/chameleon-theme-wl';
import { pascalize } from '../../utils';
/**
 * @param {string} color - name of the color from the tokenset, the color must start with 'color')
 * @returns - [undefined, style]
 *
 * @example
 * const [, colorStyle] getColor('colorPrimaryBase');
 */

var getColor = function getColor(color) {
  if (!color) {
    return [undefined, undefined];
  }

  if (!color.includes('color')) {
    var colorName = "color" + pascalize(color);
    return [undefined, tokens[colorName]];
  }

  return [undefined, tokens[color]];
};
/**
 * @param {string} color - name of the color from the tokenset, the color must start with 'color')
 * @returns - associative text color hex value
 *
 * @example
 * getTextColor('colorPrimaryBase');
 */


export var getTextColor = function getTextColor(color) {
  if (!color) {
    return [undefined, undefined];
  }

  var returnColor;

  if (color.toLowerCase().includes('black')) {
    return [undefined, '#ffffff'];
  }

  if (color.toLowerCase().includes('white')) {
    return [undefined, '#000000'];
  }

  if (color.includes('Base') || color.includes('Light') || color.includes('Dark')) {
    if (!color.includes('color')) {
      var colorName = "colorText" + pascalize(color);
      returnColor = tokens[colorName];
    } else {
      returnColor = tokens[("" + color).replace('color', 'colorText')];
    }
  }

  [10, 20, 30, 40, 50, 60, 70, 80, 90, 100].forEach(function (shade) {
    if (color.includes("" + shade)) {
      returnColor = tokens["colorText" + shade];
    }
  });
  return [undefined, returnColor];
};
export default getColor;